<dl class="definition-list is-multiline">
  <div class="definition" *ngFor="let app of featuresVM">
    <dt class="term term-custom-padding">{{ app.applicationName }}</dt>
    <dd class="description">
      <div *ngFor="let feature of app.features">{{ feature }}</div>
    </dd>
  </div>
</dl>
